import { createContext, useContext, useMemo } from "react";
import type { ReactNode } from "react";

export interface ChromeValue {
  /**
   * When true, the surrounding surface owns its own navigation chrome
   * (e.g. a desktop sidebar or a wizard step bar). Components like
   * BottomNav should suppress themselves to avoid duplicate navigation.
   */
  desktopChrome: boolean;
}

const DEFAULT: ChromeValue = { desktopChrome: false };

const ChromeContext = createContext<ChromeValue>(DEFAULT);

export function ChromeProvider({
  value,
  children,
}: {
  value?: Partial<ChromeValue>;
  children: ReactNode;
}) {
  const merged = useMemo<ChromeValue>(
    () => ({ ...DEFAULT, ...value }),
    [value?.desktopChrome],
  );
  return (
    <ChromeContext.Provider value={merged}>{children}</ChromeContext.Provider>
  );
}

export function useChrome(): ChromeValue {
  return useContext(ChromeContext);
}
